var _rect, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSwitchCompanyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5114_19044",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5114_19044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 13.3332L4.3987 12.3832L6.11536 10.6665H1.33203V9.33317H6.11536L4.3987 7.6165L5.33203 6.6665L8.66536 9.99984L5.33203 13.3332ZM10.6654 9.33317L7.33203 5.99984L10.6654 2.6665L11.5987 3.6165L9.88203 5.33317H14.6654V6.6665H9.88203L11.5987 8.38317L10.6654 9.33317Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCompanyIcon);
export default __webpack_public_path__ + "static/media/SwitchCompanyIcon.51cebb22de224698e88a96291c16537e.svg";
export { ForwardRef as ReactComponent };